import { useContext } from 'react';
import { AjusteDeEstoqueContextData } from '../types/context';
import { AjusteDeEstoqueContext } from '../context/AjusteDeEstoqueContext';

export const useAjusteDeEstoque = (): AjusteDeEstoqueContextData =>
  useContext(AjusteDeEstoqueContext);
